/**
 * Where a coach mark's balloon goes, vertically, given how tall it really is.
 *
 * It used to go below whenever 200px were free, and the balloon is taller
 * than that: on a small monitor its buttons ended up under the bottom of the
 * window, and the guide read as missing ("monitor pequeno o guide … fica
 * escondida", 2026-09-29).
 *
 * Below if it fits, above if that fits, and otherwise on the roomier side,
 * pulled inside the window -- covering part of the target rather than hiding
 * its own buttons. `tail` is `none` then, since there is nothing to point from.
 */
export interface BalloonPlacement {
  top: number
  tail: 'top' | 'bottom' | 'none'
}

export function placeBalloon(
  target: { top: number; bottom: number },
  height: number,
  viewportHeight: number,
  gap: number,
  edge: number,
): BalloonPlacement {
  const roomBelow = viewportHeight - target.bottom - gap - edge
  const roomAbove = target.top - gap - edge
  if (height <= roomBelow) return { top: target.bottom + gap, tail: 'top' }
  if (height <= roomAbove) return { top: target.top - gap - height, tail: 'bottom' }

  const preferred = roomBelow >= roomAbove ? target.bottom + gap : target.top - gap - height
  const top = Math.max(edge, Math.min(preferred, viewportHeight - height - edge))
  return { top, tail: 'none' }
}
